<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
    >
        <path
            d="M9.40551 10.2453C9.04885 9.66867 8.47773 9.52979 8.03329 9.52979C7.56551 9.52979 6.33773 9.77867 6.45218 10.9576C6.53218 11.7853 7.31218 12.0931 7.99329 12.2142C8.6744 12.3353 9.6644 12.5953 9.68885 13.5931C9.70996 14.4365 8.95107 15.012 8.0344 15.012C7.2744 15.012 6.71662 14.7565 6.42773 14.1853"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 8.61206V9.52984"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 15.0132V15.8343"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.9451 5.83434L12.1673 2.501C12.1673 1.88767 11.6695 1.38989 11.0562 1.38989H8.00065H4.9451C4.33176 1.38989 3.83398 1.88767 3.83398 2.501L6.05621 5.83434H9.9451Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 5.83439V4.16772"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.05621 5.83423C3.39954 7.25756 1.33398 10.852 1.33398 13.8898C1.33398 17.572 4.31843 18.612 8.00065 18.612C11.6829 18.612 14.6673 17.572 14.6673 13.8898C14.6673 10.852 12.6018 7.25756 9.94509 5.83423"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
